var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalInformation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18579_62672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18579_62672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83464 14.9993H7.5013V13.3327H9.16797V11.666H7.5013V9.99935H5.83464V11.666H4.16797V13.3327H5.83464V14.9993ZM10.8346 12.0827H15.8346V10.8327H10.8346V12.0827ZM10.8346 14.5827H14.168V13.3327H10.8346V14.5827ZM3.33464 18.3327C2.8763 18.3327 2.48394 18.1695 2.15755 17.8431C1.83116 17.5167 1.66797 17.1243 1.66797 16.666V7.49935C1.66797 7.04102 1.83116 6.64865 2.15755 6.32227C2.48394 5.99588 2.8763 5.83268 3.33464 5.83268H7.5013V3.33268C7.5013 2.87435 7.6645 2.48199 7.99089 2.1556C8.31727 1.82921 8.70964 1.66602 9.16797 1.66602H10.8346C11.293 1.66602 11.6853 1.82921 12.0117 2.1556C12.3381 2.48199 12.5013 2.87435 12.5013 3.33268V5.83268H16.668C17.1263 5.83268 17.5187 5.99588 17.8451 6.32227C18.1714 6.64865 18.3346 7.04102 18.3346 7.49935V16.666C18.3346 17.1243 18.1714 17.5167 17.8451 17.8431C17.5187 18.1695 17.1263 18.3327 16.668 18.3327H3.33464ZM3.33464 16.666H16.668V7.49935H12.5013C12.5013 7.95768 12.3381 8.35004 12.0117 8.67643C11.6853 9.00282 11.293 9.16602 10.8346 9.16602H9.16797C8.70964 9.16602 8.31727 9.00282 7.99089 8.67643C7.6645 8.35004 7.5013 7.95768 7.5013 7.49935H3.33464V16.666ZM9.16797 7.49935H10.8346V3.33268H9.16797V7.49935Z",
    fill: "#A9A9A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalInformation);
export default __webpack_public_path__ + "static/media/medical-information.667fa1c0b6a1cf6e63b22e654843385f.svg";
export { ForwardRef as ReactComponent };